import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'
import { loadInitialCounterpartyData } from './action';
import { ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from 'reactstrap';
import MyAutosuggest from '../../../../components/ReusableComponents/AutoSuggest/index';
import { DOMESTIC, INTERNATIONAL, COUNTERPARTY_CLASSIFICATION } from '../../../../Analyst/Cases/constants';
import { toast } from 'react-toastify';

const required = value => value ? null : 'Required';
const isValid = value => !value || (typeof value !=='string') || (typeof value === 'string' && value.match(/^[^<>!$%^?*~`{}=]*$/)) ? null :'Please enter valid Input';

const renderField = ({ input, label, type, isRequired, disabled, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col sm="9">
            <label className="mb-0">{label}</label>
            {(isRequired && <span className="text-danger">*</span>)}
        </Col>
        <Col sm="15">
            <input {...input} placeholder={label} disabled={disabled} type={type} className="form-control" />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)
class EditCounterpartyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialData: [],
            selectedCountry: '',
            selectedState: '',
            geographicType: ''
        }
    }

    componentDidMount() {
        this.props.load(this.props.initialValues);
    }

    componentWillUnmount() {
        this.props.load({});
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialValues !== prevProps.initialValues) {
            if (this.props.initialValues !== undefined && this.props.initialValues.pfNumber !== null) {
                this.props.initialValues.pfNumber = this.props.initialValues.pfNumber.join()
            }
            if (this.props.initialValues !== undefined) {
                if (this.props.initialValues.state === null) {
                    this.props.initialValues.state = ''
                }
                if (this.props.initialValues.country === null) {
                    this.props.initialValues.country.sortname = ''
                    this.props.initialValues.country.name = ''
                }
                this.setState({
                    initialData: this.props.initialValues,
                    selectedCountry: { id: this.props.initialValues.country.sortname, value: this.props.initialValues.country.name },
                    selectedState: { id: '', value: this.props.initialValues.state },
                    geographicType: this.props.initialValues.geographicType
                })
                this.props.change('country', { id: this.props.initialValues.country.sortname, value: this.props.initialValues.country.name })
                this.props.change('state', { id: '', value: this.props.initialValues.state })
            }
        }
    }

    searchCallback = (selected, type) => {
        if (type === 'countrySearch') {
            this.setState({
                selectedCountry: selected,
                selectedState: ''
            })
            this.props.change('country', selected)
            this.props.change('state', '')
        } else {
            this.setState({
                selectedState: selected.value
            })
            this.props.change('state', selected)
        }
    }

    handleCounterpartyGeographicChange = (event) => {
        this.setState({ geographicType: event.target.value })
        this.props.change('geographicType', event.target.value)
    }

    submitCounterparty = (val) => {
        if (this.state.selectedCountry === "") {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Choose Counterparty Country
                </div>
            );
        } else if (this.state.selectedState === "") {
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Choose Counterparty State
                </div>
            );
        }
        else {
            this.props.submitCounterpartyData(val)
        }
    }

    render() {
        const { value } = this.state;
        let field = []
        let inputPropsState = {
            placeholder: "Search State",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        }
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        };
        if (this.state.initialData) {

            field = Object.keys(this.state.initialData).map((key, index) => {
                if (key !== "createdAt" && key !== "updatedAt" && key !== "createdBy" && key !== "updatedBy" && key !== "archived") {
                    if (key === "id" || key === "uuId") {
                        return (
                            <Field
                                key={key}
                                name={key}
                                type="text"
                                component={renderField}
                                label={key}
                                disabled={true}
                            />
                        )
                    }
                    else if (key === "unique" || key === "active") {
                        return (
                            <Field
                                key={key}
                                name={key}
                                type="checkbox"
                                component={renderField}
                                label={key}
                            />
                        )
                    }
                    else if (key === "country" || key === "state" || key === "geographicType") {

                    }
                    else if (key === "pinCode") {
                        return (
                            (this.state.geographicType === DOMESTIC) ?
                                <Field
                                    key={key}
                                    name={key}
                                    type="text"
                                    component={renderField}
                                    label={key}
                                    validate={[isValid]}
                                />
                                : null
                        )
                    }
                    else if (key === "counterpartyName" || key === "address") {
                        return (
                            <Field
                                key={key}
                                name={key}
                                type="text"
                                component={renderField}
                                label={key}
                                isRequired={true}
                                validate={[required,isValid]}
                            />
                        )
                    }
                    else if (key === "gstNo" || key === "panNo") {
                        return (
                            (this.state.geographicType === DOMESTIC) ?
                                <Field
                                    key={key}
                                    name={key}
                                    type="text"
                                    component={renderField}
                                    label={key}
                                    isRequired={true}
                                    validate={[isValid]}
                                />
                                : null
                        )
                    }
                    else if (key === COUNTERPARTY_CLASSIFICATION) {
                        return (
                            <Field
                                key={key}
                                name={key}
                                type="text"
                                component={renderField}
                                label={key}
                                validate={[isValid]}
                                disabled={true}
                            />
                        )
                    }
                    else {
                        return (
                            <Field
                                key={key}
                                name={key}
                                type="text"
                                component={renderField}
                                label={key}
                                validate={[isValid]}
                            />
                        )
                    }
                }
            });

        }
        const { handleSubmit, pristine, submitting, reset } = this.props
        return (
            <Row>
                <form className="modal-content shadow-none border-0" onSubmit={handleSubmit((val) => this.submitCounterparty(val))}>
                    <ModalHeader>
                        Additional Details
                    </ModalHeader>
                    <ModalBody>
                        <Row className="mb-4">
                            <div className="col-9">
                                <label>Counterparty Geographic Type<i className='text-danger'>*</i></label>
                            </div>
                            <div className="col-15 pl-4">
                                <label style={{ marginLeft: '2%' }}>
                                    <Field name="geographicType" component="input" checked={(this.state.geographicType === DOMESTIC) ? true : false} type="radio" value={DOMESTIC} onChange={this.handleCounterpartyGeographicChange} />{' '}
                                    Domestic
                                    <Field name="geographicType" component="input" checked={(this.state.geographicType === INTERNATIONAL) ? true : false} type="radio" value={INTERNATIONAL} onChange={this.handleCounterpartyGeographicChange} />{' '}
                                    International
                                </label>
                            </div>
                        </Row>
                        {field}
                        <Row className="mb-4">
                            <div className="col-9">
                                <label>Country</label>
                                <span className="text-danger">*</span>
                            </div>

                            <div className="col-15 pl-4">
                                <MyAutosuggest
                                    id="countrySearch"
                                    placeholder="Search Country"
                                    onChange={this.handleCountryAutocomplete}
                                    searchCallback={this.searchCallback}
                                    inputProps={inputProps}
                                    searchType="countrySearch"
                                    selectedValueCountry={this.state.selectedCountry} />
                            </div>
                        </Row>
                        <Row className="mb-4">
                            <div className="col-9">
                                <label>State</label>
                                <span className="text-danger">*</span>
                            </div>
                            <div className="col-15 pl-4">
                                <MyAutosuggest
                                    id='stateSearch'
                                    placeholder="Search State"
                                    onChange={this.handleCountryAutocomplete}
                                    searchCallback={this.searchCallback}
                                    inputProps={inputPropsState}
                                    selectedValueState={this.state.selectedState}
                                    countryValue={this.state.selectedCountry.id}
                                    searchType="stateSearch" />
                            </div>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.props.handleCounterpartDataEditModelClosed()} > Cancel </Button></Col>
                            <Col ><Button type="submit" color="info" size="lg" className="justify-content-center" disabled={submitting}>Submit</Button></Col>
                        </Row>
                    </ModalFooter>
                </form>
            </Row>
        )
    }
}

EditCounterpartyForm = reduxForm({
    form: 'editCounterpartyForm', // a unique identifier for this form
    enableReinitialize: true
})(EditCounterpartyForm);

EditCounterpartyForm = connect(
    state => ({
        initialValues: state.counterpartyDataInitialValuesReducer.intialCounterpartyData // pull initial values from reducer
    }),
    { load: loadInitialCounterpartyData }, // bind addition fields loading action creator
)(EditCounterpartyForm);

export default EditCounterpartyForm;
